import { ActiveField, ActiveModel } from '@alt-point/active-models/src'

export class CategoryDto extends ActiveModel {
  @ActiveField()
  id: number = 0

  @ActiveField()
  name: string = ''

  @ActiveField()
  slug: string = ''

  @ActiveField()
  parentsIds: number[] = []

  @ActiveField()
  childrenIds: number[] = []

  @ActiveField()
  order: number = 0

  @ActiveField()
  selfAndAncestorsIds: number[] = []

  @ActiveField()
  selfAndDescendantsIds: number[] = []

  @ActiveField()
  images: string[] = []

  /**
   * SEO-мета категории, задаётся в админке. NULL/пусто — витрина генерирует
   * мету сама (SeoService). Модель рукописная: autogen не типизирует значения
   * словаря `ChannelCategoriesDto.allByIds` (там `Record<string, object>`).
   */
  @ActiveField()
  metaTitle: string | null = null

  @ActiveField()
  metaDescription: string | null = null

  @ActiveField()
  ogImageId: string | null = null
}
